<template>
	<div class="main-div">
		<router-view />
	</div>
</template>

<script>
	import Qs from 'qs';
	export default {
		name: 'App',
		data() {
		    return {
		      currentRouteName: ''
		    }
		  },
		components: {},
		mounted() {
			this.handleResize();
			window.addEventListener('resize', this.handleResize);
		},
		watch: {
		    '$route'(to, from) {
		      // 监听路由变化，更新当前路由名称
		      this.currentRouteName = to.name;
			  this.handleResize();
			  // console.log(this.currentRouteName);
		    }
		  },
		methods: {
			handleResize() {
				let this_ = this;
				if (window.innerWidth <= 750) {
					document.body.style.zoom = window.innerWidth / 750;
					if (window.innerWidth / 750 > 0.715) {
						document.body.style.zoom = 0.715;
					}

				} else if (window.innerWidth > 750 && window.innerWidth <= 980) {
					document.body.style.zoom = 0.715;

				} else {
					// console.log(this_.$store.state.toName);
					if(this_.$route.name!='pre' && this_.$route.name!='pre1' && this_.$route.name!='pre2'){
						document.body.style.zoom = 0.715;
					}else{
						document.body.style.zoom = window.innerWidth / 1920;
					}
				}

				if (window.innerWidth > 980) {
					this_.$store.commit("onchangemob", false);
					this_.$store.commit("onchangePc", true);
					this_.$store.commit("mobshowfooterfun", false);
					
				} else {
					this_.$store.commit("onchangemob", true);
					this_.$store.commit("onchangePc", false);
				}
			}
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize);
		}
	}
</script>

<style scoped="scoped">
	.main-div {
		height: 100%;
		width: 100%;
		position: relative;
		/* background-color: #445a72; */
	}

	@media screen and (max-width: 980px) {
		.main-div {
			max-width: 750px;
			margin: 0 auto;
			/* padding-bottom: 190px; */
		}
	}
</style>